import React from "react"
import PropTypes from "prop-types"
import { Box } from "@infotech/uikit-grid"
import findIndex from "lodash/findIndex"
import mapKeys from "lodash/mapKeys"
import isEmpty from "lodash/isEmpty"
import ExternalLink from "src/components/ExternalLink"
import ResourceTypesMenuIcon from "src/icons/resourceTypesMenu.svg"
import TooltipWrapper from "src/components/Tooltips/TooltipWrapper"
import ValidateCarousel from "src/components/ValidateCarousel"
import styles from "./styles.css"

const ResourcePopup = ({
  resourceData: {
    id,
    typeId,
    fields,
    title,
    typeName,
    offPlan,
    externalLink,
    isDeleted,
  },
  resourceTypes,
  resourceValidate,
  isPlan,
}) => {
  const currentFields = []
  const currentType =
    resourceTypes[findIndex(resourceTypes, item => item.id === typeId)]
  if (currentType && !isEmpty(fields)) {
    mapKeys(fields, (value, key) => {
      currentType.fields.map(
        item =>
          item.name === key &&
          currentFields.push({ id: key, name: item.label, val: value }),
      )
    })
  }
  const isInValid = isPlan && resourceValidate && resourceValidate[id]
  return (
    <Box loose flex column className={styles.PopupWrapper}>
      <TooltipWrapper
        className={styles.Tooltip}
        tooltipLabel={title}
        tooltipPosition="bottom"
        tooltipStyle={{
          margin: `-25px 0 0 -177px`,
          width: `330px`,
        }}
        tooltipFixed
      >
        <Box
          flex
          align="center"
          pl="3md"
          pr="3md"
          className={styles.PopupHeader}
        >
          <Box loose className={styles.ResourceLabel}>
            {title}
          </Box>
          {offPlan && (
            <Box
              loose
              flex
              align="center"
              ml="1md"
              pl="1md"
              shrink={0}
              className={styles.OutOfPlan}
            >
              Вне плана
            </Box>
          )}
          {isDeleted && (
            <Box
              loose
              flex
              align="center"
              ml="1md"
              pl="1md"
              shrink={0}
              className={styles.IsDeleted}
            >
              Удалён
            </Box>
          )}
        </Box>
      </TooltipWrapper>
      {isInValid && (
        <Box loose>
          <ValidateCarousel errors={resourceValidate[id]} />
        </Box>
      )}
      {externalLink && (
        <Box loose pl="2md" pt="2md">
          <ExternalLink data={externalLink} />
        </Box>
      )}
      <Box loose flex pt="2md" pl="14px" pr="2md" pb="1md">
        <ResourceTypesMenuIcon color="#3180ff" />
        <Box loose className={styles.ResourceTypeLabel}>
          {typeName}
        </Box>
      </Box>
      <Box loose className={styles.PopupBody} pb="2md">
        {currentFields.map(field => (
          <Box loose flex column pt="1md" pl="2md" pr="2md">
            <Box loose className={styles.ResourceTypeFieldsLabel}>
              {field.name}
            </Box>
            <Box loose className={styles.ResourceTypeFieldsValue}>
              {field.val}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

ResourcePopup.propTypes = {
  resourceData: PropTypes.shape({
    title: PropTypes.string,
    typeId: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    typeName: PropTypes.string,
    fields: PropTypes.object,
    offPlan: PropTypes.bool,
    isDeleted: PropTypes.bool,
  }),
  resourceTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          resourceTypeId: PropTypes.number.isRequired,
        }),
      ),
    }),
  ),
  resourceValidate: PropTypes.arrayOf(
    PropTypes.shape({
      errors: PropTypes.bool,
      violations: PropTypes.shape({
        level: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
      }),
    }),
  ),
  isPlan: PropTypes.bool.isRequired,
}

ResourcePopup.defaultProps = {
  resourceData: {},
  resourceTypes: [],
  resourceValidate: [],
}

export default ResourcePopup
